// What the best-moves place above the stage tabs shows: exactly one of the
// owner's card (while the board's Best moves visibility constraint hides the
// best moves, a puzzle), the engine shortlist, or the theory list, decided
// from the review session's `theory`. Pure, so it is tested without React.
import type { ReviewTheory } from '@chess/api-review';
import type { TheoryMove } from './TheoryList.tsx';

export type Place =
  | { kind: 'puzzle' }
  | { kind: 'engine' }
  | { kind: 'theory'; movePrefix: string; moves: TheoryMove[] };

/** Theory, with nothing to list, while the session has not decided: the game or its book is still loading. */
const UNDECIDED: ReviewTheory = { active: true, moves: [], movePrefix: '' };

/** The theory list's rows for the session's theory. */
export const toRows = (theory: ReviewTheory): TheoryMove[] => theory.moves.map((c) => ({ san: c.san, name: c.opening.name, distance: c.distance }));

/** The place's content: the puzzle's card while the best moves are hidden, then the engine shortlist unless theory is active. */
export function placeOf(bestMovesVisible: boolean, theory: ReviewTheory | undefined): Place {
  if (!bestMovesVisible) return { kind: 'puzzle' };
  const t = theory ?? UNDECIDED;
  if (!t.active) return { kind: 'engine' };
  return { kind: 'theory', movePrefix: t.movePrefix, moves: toRows(t) };
}
